/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function MusicNote(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M210.29883,56.3374l-80-24A7.99991,7.99991,0,0,0,120,40V87.82031q-.0044.1831,0,.36573v60.07519A47.97353,47.97353,0,1,0,136,184V98.75195l69.70117,20.91065A7.99991,7.99991,0,0,0,216,112V64A7.99972,7.99972,0,0,0,210.29883,56.3374Z" />
    </Svg>
  );
}

export default MusicNote;
